var exports = {
  "Vg": "ComponentGalleryTabInputsTab.module__grid___VHplZ2",
  "hK": "ComponentGalleryTabInputsTab.module__gridSingle___VHplZ2",
  "T_": "ComponentGalleryTabInputsTab.module__inlineEditWrapper___VHplZ2",
  "qF": "ComponentGalleryTabInputsTab.module__inlineEditLabel___VHplZ2",
  "WX": "ComponentGalleryTabInputsTab.module__inlineEditCaption___VHplZ2",
  "V1": "ComponentGalleryTabInputsTab.module__colorPickersGrid___VHplZ2",
};

module.exports = exports;
